// ------------------------------------
// Selectors
// ------------------------------------
export const payerAuthTree = (state) => state.payerAuth || {};
export const payerAuthIsLoading = (state) => payerAuthTree(state).isLoading;
